import { UserProfile } from "@/gen/ts/v1/user/user_service_pb";
import { routes } from "@/lib/routes";

export function computeAuthRedirectUrl({
  wasCreated,
  generatedUsername,
  userProfile,
  redirectUrl,
}: {
  wasCreated: boolean;
  generatedUsername: string | null;
  userProfile: UserProfile | null;
  redirectUrl?: string | null;
}) {
  if (userProfile?.activeOrg) {
    // Preserve redirect_url query parameter when redirecting to organizations page
    if (redirectUrl) {
      const url = new URL(routes.auth.organizations, window.location.origin);
      url.searchParams.set("redirect_url", redirectUrl);
      return `${url.pathname}${url.search}`;
    }
    return routes.auth.organizations;
  }

  if (wasCreated && !redirectUrl && generatedUsername) {
    return routes.user.profile(generatedUsername);
  }

  const destination = redirectUrl ?? routes.home;

  // Build destination URL with query parameters
  const url = new URL(destination, window.location.origin);
  if (wasCreated) {
    url.searchParams.set("new_user", "1");
  }
  if (generatedUsername) {
    url.searchParams.set("generated_username", generatedUsername);
  }

  // Navigate only AFTER all async operations complete
  const finalUrl = `${url.pathname}${url.search}${url.hash}`;
  return finalUrl;
}
